import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type Replay15IconProps = IconProps;

export const Replay15Icon = forwardRef<SVGSVGElement, Replay15IconProps>(
  function Replay15Icon(props: Replay15IconProps, ref) {
    return (
      <Icon
        data-testid="Replay15Icon"
        aria-label="replay 15"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M7.979 2c2.249 0 4.061 1.835 4.02 4.071C11.96 8.252 10.171 10 7.979 10H4v2L0 9.5 4 7v2h3.979a3.008 3.008 0 0 0 3.015-2.946A3.008 3.008 0 0 0 7.979 3V2zM2.426 5.25h-.807V2.034l.003-.321.007-.314c.005-.103.01-.201.017-.294a2.318 2.318 0 0 1-.178.171 7.906 7.906 0 0 1-.219.191l-.574.458-.403-.509L1.755.254h.67v4.997z" />
        <path d="M5.269 2.126c.321 0 .604.058.848.174.246.114.437.283.574.506.137.221.205.492.205.813 0 .351-.074.654-.222.909-.148.253-.366.448-.653.584s-.637.205-1.049.205c-.262 0-.507-.023-.735-.068a2.033 2.033 0 0 1-.584-.205v-.725a2.867 2.867 0 0 0 1.302.325c.232 0 .432-.034.598-.103s.294-.173.383-.314a.973.973 0 0 0 .137-.537c0-.287-.092-.508-.277-.663-.182-.157-.468-.236-.858-.236-.137 0-.283.013-.437.038-.153.023-.28.048-.383.075l-.352-.208.188-2.444h2.598V.96h-1.89l-.109 1.244c.082-.018.18-.035.294-.051.114-.018.255-.027.424-.027z" />
      </Icon>
    );
  }
);
